// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1ITjx","modalForm":"UpgradeEpcsModal_modalForm__3sy7A","modalFooter":"UpgradeEpcsModal_modalFooter__uph4_"};